import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from '../authentication.service';
import { DEVAPI_BUILD, PRODUCTION_BUILD } from '../../../+app-custom/app.settings';
import { AppRedirectService } from '../app-redirect.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private appRedirectService: AppRedirectService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let returnUrl = true;

    if (!PRODUCTION_BUILD && !DEVAPI_BUILD) {
      if (
        route.queryParams &&
        route.queryParams.development &&
        decodeURIComponent(route.queryParams.development) === 'true'
      ) {
        console.log(route.queryParams);
        if (route.queryParams.user) {
          this.authenticationService.saveLoggedUserFromEncrypted(decodeURIComponent(route.queryParams.user));
        }
      }
    } else {
      if (route.url && route.url[0] && route.url[0].path === 'dev') {
        this.router.navigate(['']);
        return false;
      }
    }

    if (this.authenticationService.checkForUserCookie() && !AuthenticationService.isSessionExpired()) {
      this.authenticationService.checkTokenRefreshRequirement();

      if (AuthenticationService.checkSystemAccessPermission()) {
        return true;
      } else {
        returnUrl = false;
      }
    }

    this.appRedirectService.redirectLogin(returnUrl);
    return false;
  }
}
